module.exports = __webpack_public_path__ + "img/session1_logo1.e23b0312.png";